export const roomTypesEnum: { [key: number]: string } = {
    1: 'Single',
    2: 'Double',
    3: 'Triple',
    4: 'Quad'
};
